import { TProduct } from "@jsdev_ninja/core";

// Step the qty stepper uses for weight/measured products (kg, gram, …).
export const WEIGHT_STEP = 0.5;
export const WEIGHT_MIN = 0.01;

// Weight/measured products (kg, gram, liter, ml) are ordered by a fractional
// amount (e.g. 4.8 kg); only "unit" products are whole-number. Missing
// priceType falls back to unit behaviour.
export function isWeightProduct(product: TProduct | undefined): boolean {
	const type = product?.priceType?.type;
	return !!type && type !== "unit";
}

// Round to 3 decimals to keep weights clean and avoid float drift (0.1+0.2…).
export function roundQty(n: number): number {
	return Math.round(n * 1000) / 1000;
}

// Clamp a typed/stepped qty. FRACTIONS ARE ALLOWED FOR EVERY PRODUCT, not only
// weight-typed ones: this store sells by unit but bills by the actual weighed
// amount (e.g. a plum line ordered as "1" is billed as 1.025 kg), and many
// weighed products are configured with priceType "unit"/missing — rounding
// those to whole numbers made it impossible for the admin to enter the real
// weight. Only the minimum differs: weight items may go down to WEIGHT_MIN,
// unit items keep a floor of 1.
export function clampQty(n: number, weight: boolean): number {
	const min = weight ? WEIGHT_MIN : 1;
	return Math.max(min, roundQty(n));
}
